import React, { useState, useEffect } from "react";
import classes from "./Menu.module.css";

//icons
import clinics from "../../../images/svgs/appointments.svg";
import diagnostic from "../../../images/svgs/diagnostic.svg";
import rehab from "../../../images/svgs/rehab.svg";
import museum from "../../../images/svgs/museum.svg";
import school from "../../../images/svgs/school2.svg";
import medicine from "../../../images/svgs/medicine.svg";

//libraries
import { Link } from "react-router-dom";

//This component displays the Departments' Menu
/*
props.small: indicates if the departments component should be displayed in smaller form (without icons)
this happens in the pages other than the main one
*/
const Menu = (props) => {
  const [imgClass, setImgClass] = useState(classes.icon);
  const [containerClass, setconatinerClass] = useState(classes.container);

  useEffect(() => {
    if (props.small === true) {
      setImgClass(classes.smallIcon);
      setconatinerClass(classes.containerSmall);
    }
  }, [props.small]);

  return (
    <div className={containerClass}>
      {/* <h1>Our Departments</h1> */}
      <div className={classes.row}>
        <Link to="/clinics">
          <div className={classes.department}>
            {props.small ? (
              <h4>Specialized Clinics</h4>
            ) : (
              <>
                <img
                  src={clinics}
                  alt={"Specialized clinics"}
                  className={imgClass}
                />
                <h3>Specialized Clinics</h3>
              </>
            )}
          </div>
        </Link>
        <Link to="/diagnostic">
          <div className={classes.department}>
            {props.small ? (
              <h4>Diagnostic Services</h4>
            ) : (
              <>
                <img
                  src={diagnostic}
                  alt={"Diagnostic Services"}
                  className={imgClass}
                />
                <h3>Diagnostic Services</h3>
              </>
            )}
          </div>
        </Link>
        <Link to="/rehabilitation">
        <div className={classes.department}>
          {props.small ? (
            <h4>Rehabilitation services</h4>
          ) : (
            <>
              <img
                src={rehab}
                alt={"Rehabilitation services"}
                className={imgClass}
              />
              <h3>Rehabilitation services</h3>
            </>
          )}
        </div>
        </Link>
        <Link to="/school">
          <div className={classes.department}>
            {props.small ? (
              <h4>LWAH School of Excellence</h4>
            ) : (
              <>
                <img
                  src={school}
                  alt={"LWAH School of Excellence"}
                  className={imgClass}
                />
                <h3>LWAH School of Excellence</h3>
              </>
            )}
          </div>
        </Link>
        <div className={classes.department}>
          {props.small ? (
            <h4>Medicines and medical supplies</h4>
          ) : (
            <>
              <img
                src={medicine}
                alt={"Medicines and medical supplies"}
                className={imgClass}
              />
              <h3>Medicines and medical supplies</h3>
            </>
          )}
        </div>
        <Link to="/exhibitions">
          <div className={classes.department}>
            {props.small ? (
              <h4>Exhibitions and handicrafts</h4>
            ) : (
              <>
                <img
                  src={museum}
                  alt={"Exhibitions and handicrafts"}
                  className={imgClass}
                />
                <h3>Exhibitions and handicrafts</h3>
              </>
            )}
          </div>
        </Link>
      </div>
    </div>
  );
};
export default Menu;
